import { toast } from 'react-toastify'

const getHeaderValue = (headers, key) => {
  if (!headers) return null
  return headers[key] || headers[key.toLowerCase()] || headers[key.toUpperCase()]
}

export const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) return null

  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1].replace(/['"]/g, ''))
  }

  const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/i)
  return filenameMatch?.[1] || null
}

export const downloadBlobFile = ({
  data,
  fileName,
  contentType,
  successMessage,
  showSuccessToast = true,
}) => {
  const blob =
    data instanceof Blob
      ? data
      : new Blob([data], contentType ? { type: contentType } : undefined)
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)

  if (showSuccessToast && successMessage) {
    toast.success(successMessage, { hideProgressBar: false })
  }
}

export const downloadResponseFile = (
  response,
  {
    fileName = 'download',
    contentType,
    successMessage,
    showSuccessToast = true,
  } = {}
) => {
  const responseContentType = getHeaderValue(response?.headers, 'content-type')
  const contentDisposition = getHeaderValue(response?.headers, 'content-disposition')
  const resolvedFileName = getFilenameFromContentDisposition(contentDisposition) || fileName

  downloadBlobFile({
    data: response?.data,
    fileName: resolvedFileName,
    contentType: responseContentType || contentType,
    successMessage,
    showSuccessToast,
  })

  return resolvedFileName
}

export const downloadUrlFile = ({
  url,
  fileName,
  successMessage,
  showSuccessToast = true,
  revokeObjectUrl = false,
}) => {
  const link = document.createElement('a')

  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  link.remove()

  if (revokeObjectUrl) {
    window.URL.revokeObjectURL(url)
  }

  if (showSuccessToast && successMessage) {
    toast.success(successMessage, { hideProgressBar: false })
  }
}

export const notifyDownloadError = (message = 'Unable to download file. Please try again.') => {
  toast.error(message, { hideProgressBar: false })
}
